import $ from 'jquery';

$(document).ready(function() {
    $('footer a.heateor_sss_linkedin').click(function(e) {
        e.stopPropagation();
    })
    $('footer .heateor_sss_follow_icons_container').click(function(e) {
        $('a.heateor_sss_linkedin')[0].click();
    });
})